// extracted by mini-css-extract-plugin
export default {"wrapper":"camera_wrapper__Cv7sV","camera":"camera_camera__W4HvW","capture":"camera_capture__GQ0P9","rotate":"camera_rotate__3sCpZ"};